import { Controller } from '@hotwired/stimulus';

export class FlashMessageController extends Controller {
    declare readonly progressBarTarget: HTMLElement;
    declare readonly hasProgressBarTarget: boolean;

    static targets = ['progressBar'];

    private autoDismissTimer: number | null = null;
    private isClosing = false;

    connect() {
        // Wait a millisecond to add the classes to transition in, otherwise the animation is skipped
        setTimeout(() => {
            this.element.classList.add('translate-y-0', 'opacity-100', 'sm:translate-x-0');
            this.element.classList.remove('translate-y-2', 'opacity-0', 'sm:translate-y-0', 'sm:translate-x-2');
        }, 1);

        // Start progress bar animation and auto-dismiss timer
        this.startAutoDismiss();
    }

    disconnect() {
        // Clear timer if component is removed
        if (this.autoDismissTimer) {
            window.clearTimeout(this.autoDismissTimer);
        }
    }

    close() {
        if (this.isClosing) {
            return;
        }
        this.isClosing = true;

        // Cancel auto-dismiss if user manually closes
        if (this.autoDismissTimer) {
            window.clearTimeout(this.autoDismissTimer);
        }

        // Trigger mobile-style swipe/fade dismissal that matches native toasts
        const toast = this.element as HTMLElement;
        toast.classList.remove('translate-y-0', 'opacity-100', 'sm:translate-x-0');
        toast.classList.add('mobile-toast-dismiss');

        toast.addEventListener(
            'animationend',
            () => {
                toast.remove();
            },
            { once: true }
        );
    }

    private startAutoDismiss() {
        // Animate progress bar from 100% to 0% over 3 seconds
        if (this.hasProgressBarTarget) {
            // Small delay to ensure DOM is ready
            setTimeout(() => {
                this.progressBarTarget.style.width = '0%';
            }, 10);
        }

        // Auto-dismiss after 3 seconds
        this.autoDismissTimer = window.setTimeout(() => {
            this.close();
        }, 3000);
    }
}
